import SsgMain from './main/index'
import entry from './entry/entry.vue'
import SsgPersonSet from './settings/person.vue'
import SsgChangePasswd from './settings/changepasswd.vue'
import System from './system/index.vue'
import SsgNoPermission from './settings/nopermission.vue'
import StopUsing from './settings/stopusing.vue'
import CompanyId from './system/newvalidate/index.vue'
import AccountCllect from './system/newvalidate/accountCllect.vue'
import LicenceCllect from './system/newvalidate/licenceCllect.vue'
import RealName from './system/newvalidate/realName.vue'


const components = [
  SsgMain,
  entry,
  SsgPersonSet,
  SsgChangePasswd,  
  System,
  SsgNoPermission,
  StopUsing,
  CompanyId,
  LicenceCllect,
  AccountCllect,
  RealName
]

const install = function(Vue, opts = {}) {
  
  components.forEach(component => {
    Vue.component(component.name, component);
  });

};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

const aa = {
  install,
  SsgMain,
  entry,
  SsgPersonSet,
  SsgChangePasswd,
  System,
  SsgNoPermission,
  StopUsing,
  CompanyId,
  LicenceCllect,
  AccountCllect,
  RealName
}

export default aa;